import React, { useState, useEffect } from 'react';
import { useToast } from './ToastContext';
import type { Toast } from './ToastContext';
import './Toast.css';

function ToastItem({ toast, onDismiss }: { toast: Toast; onDismiss: () => void }) {
  const [exiting, setExiting] = useState(false);

  function handleDismiss() {
    setExiting(true);
    setTimeout(onDismiss, 250); // match slide-out duration
  }

  // For auto-dismiss: start exit animation 250ms before removal
  useEffect(() => {
    if (toast.type === 'error') return;
    const timer = setTimeout(() => setExiting(true), 5750);
    return () => clearTimeout(timer);
  }, [toast.type]);

  return (
    <div className={`toast toast--${toast.type}${exiting ? ' toast--exiting' : ''}`}>
      <span className="toast-message">{toast.message}</span>
      <button className="toast-dismiss" onClick={handleDismiss} aria-label="Dismiss">
        &times;
      </button>
    </div>
  );
}

export default function ToastContainer() {
  const { toasts, removeToast } = useToast();

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map(toast => (
        <ToastItem
          key={toast.id}
          toast={toast}
          onDismiss={() => removeToast(toast.id)}
        />
      ))}
    </div>
  );
}
